// src/components/PageLayout.jsx
import React from "react";
import "./Dashboard.css";
import Sidebar from "./Sidebar";

export default function PageLayout({ children, title }) {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-main">
        {title && (
          <header className="main-header">
            <h1>{title}</h1>
          </header>
        )}
        {children}
      </main>
    </div>
  );
}